import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
        <div className="mb-8">
          <Link
            to="/login"
            className="text-green-600 hover:text-green-700 font-medium inline-flex items-center"
          >
            <i className="bx bx-arrow-back mr-2"></i>
            Retour à la connexion
          </Link>
        </div>

        <h1 className="text-4xl font-bold text-gray-900 mb-8">
          Politique de Confidentialité
        </h1>

        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Introduction
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              La présente Politique de Confidentialité décrit la manière dont
              La Compassion collecte, utilise et protège vos informations
              personnelles lorsque vous utilisez notre application de gestion
              médicale.
            </p>
            <p className="text-gray-700 leading-relaxed">
              En utilisant nos services, vous acceptez les pratiques décrites
              dans cette politique.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. Informations Collectées
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Nous collectons les types d'informations suivants :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>
                <strong>Informations personnelles :</strong> nom, prénom, adresse
                email, numéro de téléphone
              </li>
              <li>
                <strong>Informations médicales :</strong> dossiers médicaux,
                consultations, prescriptions, résultats d'examens
              </li>
              <li>
                <strong>Informations de connexion :</strong> identifiants,
                adresses IP, journaux d'activité
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. Utilisation des Informations
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Nous utilisons vos informations pour :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Fournir et améliorer nos services médicaux</li>
              <li>Gérer vos rendez-vous et consultations</li>
              <li>Communiquer avec vous concernant vos soins</li>
              <li>Respecter nos obligations légales et réglementaires</li>
              <li>Améliorer la sécurité et prévenir la fraude</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Protection des Données
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Nous mettons en œuvre des mesures de sécurité techniques et
              organisationnelles appropriées pour protéger vos données
              personnelles contre l'accès non autorisé, la perte, la destruction
              ou la modification.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Toutes les données médicales sont traitées conformément aux
              réglementations en vigueur sur la protection des données de santé.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              5. Partage des Informations
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Nous ne vendons, ne louons ni ne partageons vos informations
              personnelles avec des tiers, sauf dans les cas suivants :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Avec votre consentement explicite</li>
              <li>Pour respecter une obligation légale</li>
              <li>Avec des prestataires de services de confiance sous contrat</li>
              <li>En cas d'urgence médicale</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              6. Vos Droits
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Vous avez le droit de :
            </p>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Accéder à vos données personnelles</li>
              <li>Demander la correction de données inexactes</li>
              <li>Demander la suppression de vos données</li>
              <li>Vous opposer au traitement de vos données</li>
              <li>Demander la portabilité de vos données</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              7. Conservation des Données
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Nous conservons vos données personnelles et médicales conformément
              aux exigences légales applicables. Les dossiers médicaux sont
              conservés selon les durées prescrites par la réglementation en
              vigueur.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              8. Modifications
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Nous nous réservons le droit de modifier cette Politique de
              Confidentialité à tout moment. Les modifications seront publiées
              sur cette page avec une date de mise à jour révisée.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              9. Contact
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Pour toute question concernant cette Politique de Confidentialité
              ou pour exercer vos droits, veuillez nous contacter à :
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Email :</strong> cabinetcompassion@gmail.com
              <br />
              <strong>Téléphone :</strong> +229 01 98 74 96 96
            </p>
          </section>

          <div className="mt-8 pt-8 border-t border-gray-200 text-sm text-gray-500">
            <p>Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

